import Bayer from '@/assets/clients/our-clients-companies/bayer.png';
import Benzinga from '@/assets/clients/our-clients-companies/benzinga.png';
import DearBrightly from '@/assets/clients/our-clients-companies/dear-brightly.png';
import EnergyLandia from '@/assets/clients/our-clients-companies/energy-landia.png';
import Esky from '@/assets/clients/our-clients-companies/esky.png';
import Fayre from '@/assets/clients/our-clients-companies/fayre.png';
import Foodstuff from '@/assets/clients/our-clients-companies/foodstuff.png';
import Google from '@/assets/clients/our-clients-companies/google.png';
import Indio from '@/assets/clients/our-clients-companies/indio.png';
import Ing from '@/assets/clients/our-clients-companies/ing.png';
import Junction from '@/assets/clients/our-clients-companies/junction.png';
import Manduka from '@/assets/clients/our-clients-companies/manduka.png';
import Messyfm from '@/assets/clients/our-clients-companies/messyfm.png';
import Microsoft from '@/assets/clients/our-clients-companies/microsoft.png';
import ModernHealth from '@/assets/clients/our-clients-companies/modern-health.png';
import Oracle from '@/assets/clients/our-clients-companies/oracle.png';
import Pegasus from '@/assets/clients/our-clients-companies/pegasus.png';
import Pulsar from '@/assets/clients/our-clients-companies/pulsar.png';
import Siren from '@/assets/clients/our-clients-companies/siren.png';
import Unicef from '@/assets/clients/our-clients-companies/unicef.png';
import Whitesky from '@/assets/clients/our-clients-companies/whitesky.png';
import Yogo from '@/assets/clients/our-clients-companies/yogo.png';

import type { ImgToClient } from '../type';

export const ourClientsCompaniesList = {
  bayer: Bayer,
  benzinga: Benzinga,
  dearBrightly: DearBrightly,
  energyLandia: EnergyLandia,
  esky: Esky,
  google: Google,
  indio: Indio,
  ing: Ing,
  junction: Junction,
  microsoft: Microsoft,
  modernHealth: ModernHealth,
  oracle: Oracle,
  pegasus: Pegasus,
  pulsar: Pulsar,
  siren: Siren,
  unicef: Unicef,
  whitesky: Whitesky,
  yogo: Yogo,
  foodstuff: Foodstuff,
  fayre: Fayre,
  manduka: Manduka,
  messyfm: Messyfm,
} satisfies ImgToClient;
